<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 36 36" xml:space="preserve" :class="classes"><circle cx="18" cy="18" r="18" fill="#707171"/> <path d="M19.83 9.34c0 .25-.05.48-.15.7a1.94 1.94 0 01-.98.98c-.22.1-.46.14-.7.14-.25 0-.48-.05-.7-.14a1.94 1.94 0 01-.98-.98c-.1-.21-.14-.45-.14-.7 0-.25.05-.49.14-.71.1-.23.23-.42.4-.59.17-.17.36-.3.58-.4.22-.1.45-.14.7-.14.25 0 .48.05.7.14.22.09.42.23.58.4.17.17.3.36.4.59.1.23.15.46.15.71zm-.58 4.58V28.5h-2.56V13.92h2.56z" fill="#fff"/></svg>
</template>

<script>
    export default {
        props: { classes: String }
    }
</script>